<template>
  <div class="comment">
    <comment-title :titleText="`评论(${commentTotal})`"></comment-title>
    <el-form ref="form" :model="form" label-width="80px">
      <el-input
        type="textarea"
        :rows="10"
        placeholder="请发表你的评论..."
        v-model="form.desc"
      ></el-input>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交评论</el-button>
      </el-form-item>
    </el-form>

    <div class="comment_box" style="overflow-y:auto">
      <el-row v-for="(v, index) of commentLists" :key="index">
        <el-col :span="2">
          <div class="grid-content bg-purple">
            <el-avatar :src="`${v.head_portrait}`"></el-avatar>
          </div>
        </el-col>
        <el-col :span="22">
          <div class="grid-content bg-purple-light">
            <div class="username">{{ v.nickname }}</div>
            <div class="time">{{ v.created_at }}</div>
            <div class="text">{{ v.comment }}</div>
          </div>
        </el-col>
      </el-row>
      <div class="btns">
        <el-button v-if="hasPage" @click="getMoreList">加载更多</el-button>
        <div v-else class="noLoad">没有更多了...</div>
      </div>
    </div>
  </div>
</template>
<script>
import CommentTitle from "@/components/Title";
export default {
  name: "CommentDetails",
  props: ["activityId", "workId"],
  components: {
    CommentTitle
  },
  data() {
    return {
      form: {
        desc: ""
      },
      workIds: "",
      activityIds: "",
      commentLists: [],
      comment_num: "",
      page: 1,
      canLoad: 0,
      showBtn: true,
      // 
      commentTotal: 0,
    };
  },
  computed:{
    hasPage(){
      return this.commentLists.length < this.commentTotal;
    }
  },

  mounted() {
    this.canLoad = 0;
  },
  watch: {
    workId(newval, oldval) {
      console.log("newval");
      this.workIds = newval;
      this.commentList(this.page);
    },
    activityId(newval, oldval) {
      this.activityIds = newval;
    }
  },
  methods: {
    onSubmit() {
      if (this.form.desc === "") {
        this.$message("评论不能为空!");
        return;
      }
      var params = {
        comment: this.form.desc,
        activity_works_id: this.workId,
        activity_id: this.activityId
      };
      this.$api
        .submitComment(params)
        .then(res => {
          if (res.code === 200) {
            this.form.desc = "";
            this.$message(res.message);
            // this.commentList(this.page);
            this.getCommentList();
          } else {
            this.$message(res.message);
          }
        })
        .catch(err => console.log(err));
    },
    commentList(page) {
      this.$api
        .loadComments({ activity_works_id: this.workIds, page: this.page })
        .then(res => {
          this.comment_num = res.data.comment_num;
          this.$emit("commentNum", this.comment_num);
          if (res.code == 200 && res.data.comment_list.length != 0) {
            if (this.page == 1) {
              this.commentLists = res.data.comment_list;
            } else {
              this.commentLists = this.commentLists.concat(
                res.data.comment_list
              );
            }
          } else {
            this.canLoad = 1;
            this.showBtn = false;
          }
        })
        .catch(err => console.log(err));
    },
    loadMore: function() {
      this.page += 1;
      if (this.canLoad == 0) {
        this.commentList(this.page);
      } else {
      }
    },

    async getCommentList(page = 1) {
      try {
        const res = await this.$api.loadComments({
          activity_works_id: this.workId,
          page: page
        });
        this.$emit("commentNum", res.data.comment_num);
        // console.log("===");
        // console.log(res);
        if (res.code == 200) {
          const { comment_num, comment_list } = res.data;
          this.commentTotal = comment_num;
          this.page = page;
          this.commentLists =
            page == 1 ? comment_list : [...this.commentLists, ...comment_list];
        } else {
          this.canLoad = 1;
          this.showBtn = false;
        }
      } catch (err) {
        throw Error(err);
      }
    },
    getMoreList() {
      this.getCommentList(this.page + 1);
    }
  },
  created() {
    console.log("created", this.workId);
    // this.commentList();
    this.getCommentList();
  },
  mounted() {
    console.log("mounted", this.workId);
  }
};
</script>
<style scoped>
.comment {
  width: 1200px;
  margin: 40px auto;
}
.el-form {
  margin: 20px 0px;
}
.el-textarea {
  display: block;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 10px;
  outline: none;
}
.el-form-item {
  text-align: right;
}
.el-button {
  margin-top: 20px;
}
.username {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #58b75b;
}
.time {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 10px 0px;
}
.comment {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.bg-purple {
  text-align: center;
}
.el-row {
  margin-bottom: 40px;
}
.comment_box {
  height: 500px;
}
.btns {
  text-align: center;
}
.noLoad {
  text-align: center;
  font-size: 14px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/workdetails/components/comment.vue